import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=5437c5ea&scoped=true&"
var script = {}
import style0 from "./Join.vue?vue&type=style&index=0&id=5437c5ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5437c5ea",
  null
  
)

export default component.exports